import Products from 'merchandise-lib/constants/Product';
import * as CurrencyCodes from '../constants/CurrencyCodes';
import * as UpgradeProducts from '../constants/UpgradeProducts';
const currencyCodeValues = Object.values(CurrencyCodes || {});
const upgradeProductValues = Object.values(UpgradeProducts || {});
export const isCurrencyCode = currencyCode => {
  return currencyCodeValues.indexOf(currencyCode) !== -1;
};
export const isUpgradeProduct = upgradeProduct => {
  return upgradeProductValues.indexOf(upgradeProduct) !== -1;
};
export const isQuantityPackDetails = sku => {
  return sku.skuType === 'QUANTITY_PACK';
};
export const isProductVersion = sku => {
  return sku.skuType === 'PRODUCT_VERSION';
};
const SalesServiceProOrEntApiNames = [Products.SALES_HUB_PROFESSIONAL, Products.SALES_HUB_ENTERPRISE, Products.SERVICE_HUB_PROFESSIONAL, Products.SERVICE_HUB_ENTERPRISE];
export const isSalesServiceProOrEnt = apiName => {
  return SalesServiceProOrEntApiNames.some(name => name === apiName);
};
const CoreSeatsApiNames = [Products.CORE_SEATS_INCLUDED_STARTER, Products.CORE_SEATS_STARTER, Products.CORE_SEATS_PROFESSIONAL, Products.CORE_SEATS_ENTERPRISE];
export const isCoreSeat = apiName => {
  return CoreSeatsApiNames.some(name => name === apiName);
};